'use client'

import {useEffect} from 'react';
import {useInView} from "react-intersection-observer";

// https://www.npmjs.com/package/react-intersection-observer

export function LazyLoad({
  offset = 100, children, text = '', force = false,
  callback = null
}) {
  const
    {ref, inView} = useInView({
      // root: null, // родитель целевого элемента - область просмотра
      threshold: 0, // процент пересечения - половина изображения (0.5 - 50%)
      rootMargin: `${offset}px`,
      triggerOnce: true,
      fallbackInView: true, // inView = true если не поддерживается IntersectionObserver
    })

  useEffect(() => {
    if (inView && callback) callback()
  }, [inView, callback])

  if (
    // true ||
    !inView && !force
  )
    return <span ref={ref}/> //<Holder ref={ref} text={text} {...(holderProps || children.props)} glow={false}/>

  return children
}
